import * as React from "react";
import {ButtonComponentProps} from "../../types/types";

export const ButtonComponent = ( props: ButtonComponentProps ) => {
    let className = 'btn ';
    if ( props.type === 'primary-outline' ) {
        className += 'btn-outline-primary';
    }
    else {
        className += 'btn-primary';
    }

    if ( props.additionalCssClasses ) {
        className += ' ' + props.additionalCssClasses.join( ' ' );
    }

    if ( typeof props.theme !== 'undefined' && props.theme ) {
        className += ' ' + props.theme;
    }

    return <button disabled={props.disabled} className={className} onClick={( e ) => {
        e.preventDefault();
        props.onClick();
    }}>{props.text}</button>
};
